export default function (layoutClass) {
  if (layoutClass == 'two-column') {
    return {
      bodyClass: 'flex flex-wrap gap-y-2',
      class: '!w-1/2 px-2',
      direction: 'flex-col',
      labelClass: '!w-full',
      showErrorSpacer: false
    }
  } else if (layoutClass == 'no-outline') {
    return {
      bodyClass: 'flex flex-wrap gap-y-2 !p-0 !border-none',
      class: '!w-1/2 px-2',
      direction: 'flex-col',
      labelClass: '!w-full',
      showErrorSpacer: false
    }
  } else {
    return {
      bodyClass: 'flex flex-col gap-y-2'
    }
  }
}
